export * from './ActorRdfUpdateHypermediaSparql';
export * from './QuadDestinationSparql';
